<template>
    <Chart 
        width=""
        height=""
        id=this.chart_id
        type="polarArea"
        title="Career Chart"
        :labels='["Programming Langauage", "Backend Framework", "Fontend Framework", "Development", "Data", "Orange"]'
        :data='[70, 65, 60, 25, 40, 10]'
        :backgroundColor='["#F5B7B1", "#D2B4DE", "#AED6F1", "#ABEBC6", "#FAD7A0", "#EDBB99"]'
        :border-color="'rgba(0, 0, 0, 0.5)'"
        border-width="2"
        fill="false"
    >
    </Chart>
</template>

<script>
import Chart from './Chart'

export default {
    components: {
        Chart,
    },
    data: () => ({
        chart_id: "chart",

    }),
    methods: {
        select: function(event) {
            console.log(event); 
        }
    },
}
</script>

<style scoped>

</style>
